import BoxVue from './App.vue'
let defaults = {}
export default function(Vue) {
  const BoxConstructor = Vue.extend(BoxVue)

  function create(props, resolve) {
    const box = new BoxConstructor({
      el: document.createElement('div'),
      propsData: props
    })
    box.callback = resolve
    return box
  }

  function Box(options) {
    return new Promise(resolve => {
      const _props = setdefaults(options)
      const box = create(_props, resolve)
      document.body.appendChild(box.$el)
    })
  }

  function setdefaults(options) {
    let obj = {}
    const op = Object.assign({}, defaults, options)
    for (let key in op) {
      obj[key] = op[key]
    }

    return obj
  }

  Vue.prototype.$holidayWorkPay = Box
}



// WEBPACK FOOTER //
// ./src/UIO/holidayWorkPay/main.js